// extracted by mini-css-extract-plugin
export default {"btn":"CustomButton_btn__tVfG5","icon":"CustomButton_icon__ZsnrA"};